// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3r4p3","content":"styles_content__1Wqww","checkbox":"styles_checkbox__1Yih7","checkboxLabel":"styles_checkboxLabel__1EJxl"};